import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";
import { membersKey } from "../api/hooks/useMembers";
import { workspaceKey } from "../api/hooks/useWorkspace";
import { WORKSPACES_KEY } from "../api/hooks/useWorkspaces";
import type { Member } from "../api/types";

interface UpdateRoleInput {
  readonly userId: string;
  readonly role: "owner" | "member" | "viewer";
}

export function useUpdateMemberRole(slug: string) {
  const qc = useQueryClient();
  return useMutation<Member, ApiError, UpdateRoleInput>({
    mutationFn: ({ userId, role }) =>
      apiFetch<Member>(`/api/ws/${slug}/members/${userId}`, { method: "PATCH", body: { role } }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: membersKey(slug) });
      // Changing a role may change the CURRENT user's own role (self-demotion),
      // which gates owner-only UI — refresh the workspace + list too (bugloop L1).
      qc.invalidateQueries({ queryKey: workspaceKey(slug) });
      qc.invalidateQueries({ queryKey: WORKSPACES_KEY });
    },
  });
}
